<template>
  <Head title="Projects" />

  <BreezeAuthenticatedLayout>
    <main class="container">
      <div class="py-12">

        <div class="c-header">
          <a href="" onclick="javascript:history.back(); return false;" class="c-header__back">
            <img src="/images/icons/icon-chevron-left.svg" alt="back">
          </a>
          <h2 class="c-header--h2">課題を編集 / {{ gym.title }}</h2>
        </div>

        <div class="mt-24">

          <form @submit.prevent="updateProject">
            <div class="mt-24">
              <label for="title">課題名<span class="required">必須</span></label>
              <div class="mt-1">
                <input type="text" id="name" name="name" v-model="form.name">
                <div v-if="!form.name" class="error">課題名を入力してください</div>
              </div>
            </div>

            <div class="mt-24">
              <label for="title">グレード<span class="required">必須</span></label>
              <div class="mt-1">
                <select v-model="form.grade_id" :error="form.errors.grade" label="grade_id">
                  <option v-for="grade in grades" :value="grade.id">
                    {{grade.title}}
                  </option>
                </select>
                <div v-if="form.errors.grade_id" class="error">グレードを選択してください</div>
              </div>
            </div>

            <div class="mt-24">
              <label for="title">ウォール<span class="required">必須</span></label>
              <div class="mt-1">
                <select v-model="form.wall_id" :error="form.errors.wall" label="wall_id">
                  <option v-for="wall in walls" :value="wall.id">
                    {{wall.name}}
                  </option>
                </select>
                <div v-if="form.errors.wall_id" class="error">ウォールを選択してください</div>
              </div>
            </div>

            <div class="mt-24">
              <label for="title">カテゴリー<span class="required">必須</span></label>
              <div class="mt-1">
                <select v-model="form.category_id" :error="form.errors.category" label="category_id">
                  <option v-for="category in categories" :value="category.id">
                    {{category.name}}
                  </option>
                </select>
                <div v-if="form.errors.category_id" class="error">カテゴリーを選択してください</div>
              </div>
            </div>

            <div class="mt-24">
              <label for="title">期間</label>
              <div class="mt-1">
                <input type="date" v-model="form.startdate" onkeydown="return false" name="startdate">
                <p>〜</p>
                <input type="date" v-model="form.enddate" onkeydown="return false" name="enddate">
              </div>
            </div>

            <div class="mt-24">
              <label for="memo">メモ</label>
              <div class="mt-1">
                <textarea v-model="form.memo" name="memo" placeholder="備考欄"></textarea>
              </div>
            </div>

            <div class="mt-24">
              <label for="title">課題画像</label>
              <div class="m-2 p-2">
                <img :src="`${imgPath}${project.image}`">
              </div>
              <div class="mt-1">
                <input type="file" id="image" wire:model="newImage" name="image" 
                @input="form.image = $event.target.files[0]">
              </div>
            </div>
            <div class="mt-24">
              <button type="submit" class="c-button">変更する</button>
            </div>
          </form>

        </div>


      </div>
      <Side />
    </main>
  </BreezeAuthenticatedLayout>
</template>

<script>
  import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
  import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
  import { Inertia } from '@inertiajs/inertia';
  import Side from '@/Shared/Side'

  export default {
    components: {
      BreezeAuthenticatedLayout,
      Head,
      Link,
      useForm,
      Inertia,
      Side,
    },

    props: {
      project: Object,
      gym: Object,
      grades: Object,
      walls: Object,
      categories: Object,
      imgPath: String,
    },

    setup(props) {
      const form = useForm({
        name: props.project.name,
        grade_id: props.project.grade_id,
        wall_id: props.project.wall_id,
        category_id: props.project.category_id,
        startdate: props.project.startdate,
        enddate: props.project.enddate,
        memo: props.project.memo,
        image: props.project.image,
      });

      const grades = props.grades

      return { form };
    },

    methods: {
      updateProject() {
        Inertia.post(`/projects/${this.project.id}`, {
          _method: 'put',
          name: this.form.name,
          grade_id: this.form.grade_id,
          wall_id: this.form.wall_id,
          category_id: this.form.category_id,
          startdate: this.form.startdate,
          enddate: this.form.enddate,
          memo: this.form.memo,
          image: this.form.image
        })
      // this.form.put(route("projects.update", this.project.id));
      // },
      },
       back() {
        window.history.back();
      },
    }
  }
</script>
